import { StyledRadioInput } from './styles';

type ValueType = string | number;

interface Props <T extends ValueType>{
    text: string | React.ReactNode;
    radioId: string;
    value: T;
    currentSelected: T | null;
    setCurrentSelected: (selected: T) => void;
    isDisabled?: boolean;
}

export default function RadioInput<T extends ValueType>({
    text,
    radioId,
    value,
    currentSelected,
    setCurrentSelected,
    isDisabled,
}: Props<T>) {
    return (
        <StyledRadioInput>
            <button
                type="button"
                className={`pseudo-checkbox ${currentSelected === value ? 'active' : ''}`}
                onClick={() => {
                    setCurrentSelected(value);
                }}
                id={radioId}
                disabled={isDisabled}
            ></button>
            <label aria-disabled={isDisabled} htmlFor={radioId}>
                {text}
            </label>
        </StyledRadioInput>
    );
}
